(function () {
    "use strict";

    angular.module("app").component("rrEnrichResult", {
        template: `<i class="fa-solid fa-fw" ng-class="{ 'fa-id-card': $ctrl.result === true, 'fa-id-card invalid': $ctrl.result === false }" ng-if="$ctrl.result !== null"></i>`,
        bindings: { result: "<" }
    });
})();